"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var checkCategoryIdByPath = function checkCategoryIdByPath(_ref) {
  var paths = _ref.paths,
    id = _ref.id;
  var rootCategory = "/29/";
  var pathList = [];
  paths.forEach(function (path, index) {
    if (!path.path.includes(rootCategory)) {
      pathList.push(paths[index].path);
    }
  });
  if (pathList.length === 0) {
    return null;
  }
  if (pathList.find(function (path) {
    return path.includes("".concat(id));
  })) {
    return id;
  }
  return null;
};
var _default = checkCategoryIdByPath;
exports["default"] = _default;